import * as t from 'io-ts';

export const RBusinessHour = t.readonly(
  t.type({
    opens: t.string,
    closes: t.string,
  }),
);

const RBusinessHoursOptional = t.union([RBusinessHour, t.null]);

const RBusinessHourDays = t.readonly(
  t.partial({
    mon: RBusinessHoursOptional,
    tue: RBusinessHoursOptional,
    wed: RBusinessHoursOptional,
    thu: RBusinessHoursOptional,
    fri: RBusinessHoursOptional,
    sat: RBusinessHoursOptional,
    sun: RBusinessHoursOptional,
  }),
);

export const RBusinessHours = t.readonly(
  t.intersection([
    RBusinessHourDays,
    t.type({
      tz: t.union([t.string, t.null]),
      enabled: t.boolean,
    }),
  ]),
);

export interface BusinessHour extends t.TypeOf<typeof RBusinessHour> {}
export interface BusinessHourDays extends t.TypeOf<typeof RBusinessHourDays> {}
export interface BusinessHours extends t.TypeOf<typeof RBusinessHours> {}
